import api from '@/config/api';
import { InfluencerUser, InviteInfluencerRequest } from '@/types';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5004/api';

export const influencerMemberService = {
   // Invite new influencer member
   async inviteMember(data: InviteInfluencerRequest): Promise<InfluencerUser> {
      const response = await api.post(`${API_URL}/influencer-members/invite-member`, data);
      return response.data.data;
   },

   // Get all influencer members
   async getMembers(): Promise<{ members: InfluencerUser[]; total: number }> {
      const response = await api.get(`${API_URL}/influencer-members/members`);
      return response.data.data;
   },

   // Resend invitation to influencer member
   async resendInvitation(userId: string): Promise<void> {
      await api.post(`${API_URL}/influencer-members/resend-invitation/${userId}`);
   },

   // Remove influencer member
   async removeMember(userId: string): Promise<void> {
      await api.delete(`${API_URL}/influencer-members/members/${userId}`);
   },

   // Change influencer member role
   async changeRole(userId: string, role: 'influencer' | 'admin' | 'super admin'): Promise<void> {
      await api.put(`${API_URL}/influencer-members/members/${userId}/role`, { role });
   },
}; 